import $ from 'jQuery';


export default function() {

  $(function() {
    initialize_tables();
  });


  function initialize_tables() {
    $('.layer--entry-content table').wrap('<div class="table-wrap"></div>');
  }

}
